export default {
  name: 'ListMixin',
  data() {
    return {
      tableFieldsStatic: null
    }
  },
  computed: {
    tableFieldsDefinition() {
      if (this.model) {
        const exclude = this.model.exclude || []
        const fields = this.preFields && this.preFields.length > 0
          ? this.preFields
          : this.model.fields.filter(obj => exclude.indexOf(obj.key) === -1).map(x => {
            if (!x.class || (x.class && x.class.indexOf(`col-${x.key}`) === -1)) {
              x.class = `${x.class || ''} col-${x.key}`
            }
            return x
          })
        if (!this.model.noActions) {
          fields.unshift({ key: 'actions', label: '', class: 'col-actions' })
        }
        return fields
      } else {
        return []
      }
    },
    tableFields() {
      return this.remapTableFields()
    }
  },
  watch: {
    perPage(val) {
      if (val && this.type) {
        const perPage = this.getLocalStorage(this.preferenceStorageKey('perPage')) || {}
        perPage[this.type] = val
        this.setLocalStorage(this.preferenceStorageKey('perPage'), perPage)
      }
    },
    compact(val) {
      if (this.type) {
        const compact = this.getLocalStorage(this.preferenceStorageKey('compact')) || {}
        compact[this.type] = val
        this.setLocalStorage(this.preferenceStorageKey('compact'), compact)
      }
    }
  },
  methods: {
    remapTableFields() {
      const storedTableFields = this.getLocalStorage(this.preferenceStorageKey('tableFields'))
      const storedFields = this.type && storedTableFields ? storedTableFields[this.type] : null
      if (!storedFields) {
        this.tableFieldsStatic = this.tableFieldsDefinition
        return this.tableFieldsStatic
      }
      const customOrderedFields = [...new Set(storedFields)].filter(Boolean)
      this.tableFieldsStatic = this.tableFieldsDefinition.map(x => {
        x = { ...x, ...customOrderedFields.find(y => y.key === x.key) }
        if (x.key !== 'actions' && x.visible === false) {
          x.class += ' d-none'
        }
        return x
      }).filter(Boolean).sort((a, b) => {
        return a.order - b.order
      })
      return this.tableFieldsStatic
    },
    /**
    * Transform Snake Case string to Title Case
    * @param  {String} string The string to transform
    * @return {String}        The transformed string
    */
    snakeCaseToTitleCase(str) {
      return str.replace(/_/g, ' ').replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        }
      )
    },
    /**
     * Transform Camel Case string to Title Case
     * @param  {String} string The string to transform
     * @return {String}        The transformed string
     */
    camelCaseToTitleCase(str) {
      const result = str.replace(/([A-Z])/g, ' $1')
      return (result.charAt(0).toUpperCase() + result.slice(1)).trim()
    },
    /**
     * Returns the diff between one given date and now or two dates in a human readable string
     * @param  {String|Date} from            The "from" date (valid string or Date object)
     * @param  {String|Date} [to=Date.now()] The "to" date (valid string or Date object)
     * @return {String}                      A string with the diff like "32d 15h 23m" (can be negative if "from" is in the future)
     */
    elapsedTime(from, to = Date.now()) {
      const diffMs = this.moment.utc(to).diff(this.moment.utc(from), 'milliseconds', true)
      let diffDays = Math.floor(diffMs / 86400000)
      let diffHrs = Math.floor((diffMs % 86400000) / 3600000)
      let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000)

      // HACK for negative times offset
      diffDays = (diffMs < 0 ? -diffDays - 1 : diffDays)
      diffHrs = (diffMs < 0 ? -diffHrs - 1 : diffHrs)
      diffMins = (diffMs < 0 ? -diffMins : diffMins)

      return (diffMs < 0 ? '-' : '') + (diffDays !== 0 ? diffDays + 'd ' : '') + (diffHrs !== 0 ? diffHrs + 'h ' : '') + (diffMins !== 0 ? diffMins + 'm ' : '0m')
    },
    elapsedTimeRaw(from, to = Date.now()) {
      const diffMs = this.moment.utc(to).diff(this.moment.utc(from), 'milliseconds', true)

      return diffMs
    },
    /**
     * Copies to the Clipboard a string. Requires Toast to show copy result.
     * @param  {String} str         The string to copy to Clipboard
     * @param  {String} [type='id'] Optional. The element type you are copying to show the generic or specific result message
     * @param  {Boolean} [singleLine=false] Optional. If false it copies with new lines (adding one before the copied string)
     */
    copyToClipboard(str, type = 'id', singleLine = false) {
      let translated
      let selection
      let range
      const el = document.createElement('textarea')
      el.value = str
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      if (!singleLine) {
        selection = document.getSelection()
        range = document.createRange()
      }
      try {
        if (!singleLine) {
          range.selectNode(el)
          selection.removeAllRanges()
          selection.addRange(range)
        }
        document.execCommand('copy')
        if (!singleLine) {
          selection.removeAllRanges()
        }
        let mssg
        switch (type) {
          case 'id':
            mssg = this.$gettext('The ID has been copied to Clipboard')
            break
          case 'email':
            mssg = this.$gettext('The e-mail has been copied to Clipboard')
            break
          case '':
            mssg = this.$gettext('The data has been copied to Clipboard')
            break
          default:
            translated = this.$gettext('The %{type} has been copied to Clipboard')
            mssg = this.$gettextInterpolate(translated, { type })
        }
        this.makeToast(this.$gettext('Notice'), mssg, 'success', false, 2000)
      } catch (e) {
        let mssg
        switch (type) {
          case 'id':
            mssg = this.$gettext('The ID could NOT be copied to Clipboard')
            break
          case 'email':
            mssg = this.$gettext('The e-mail could NOT be copied to Clipboard')
            break
          case '':
            mssg = this.$gettext('The data could NOT be copied to Clipboard')
            break
          default:
            translated = this.$gettext('The %{type} could NOT be copied to Clipboard')
            mssg = this.$gettextInterpolate(translated, { type })
        }
        this.makeToast(this.$gettext('Warning'), mssg, 'danger', false, 2000)
      }
      document.body.removeChild(el)
    },
    /**
     * Shows a Toast message on screen
     * @param  {String}  title                 The top title of the Toast box
     * @param  {String}  mssg                  The message to show
     * @param  {String}  [variant='info']      The Bootstrap variant for Toast colors
     * @param  {Boolean} [append=false]        Should be appended or prepended?
     * @param  {Number|False} [autoHideDelay=false] Time in ms before auto hide the Toast or false
     * @param  {Boolean} [solid=true]          Opacity style for the Toast
     */
    makeToast(title, mssg, variant = 'info', append = false, autoHideDelay = false, solid = true, position = 'top-right') {
      const options = {
        title,
        appendToast: append,
        variant,
        solid,
        toaster: 'b-toaster-' + position
      }
      if (autoHideDelay !== false) {
        options.autoHideDelay = autoHideDelay
      } else {
        options.noAutoHide = true
      }

      this.$bvToast.toast([mssg], options)
    },
    /**
     * Auto download the data passed
     * @param  {Object} data Should contain the `data` itself, `type` and `filename` for the download
     * @param  {String}  data                  The data itself
     * @param  {String}  type                  The file type, ie.: text/csv
     * @param  {String}  filename              The name of the file to be downloaded
     */
    download(data, type, filename) {
      const blob = new Blob([data], { type })
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename)
      } else {
        const link = document.createElement('a')
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    },
    toTitleCase(str) {
      return str.replace(/_/g, ' ').replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        }
      )
    },
    setLocalStorage(key, value, updateRemote = true) {
      if (updateRemote && this.profile) {
        let meta = this.profile.meta
        if (!meta) {
          meta = {}
        }
        if (!meta.persistentStorage) {
          meta.persistentStorage = {}
        }
        meta.persistentStorage[key] = value
        this.$store.dispatch('updateUser', { meta })
      }

      if (typeof value === 'object') {
        value = JSON.stringify(value)
      }
      localStorage[key] = value
    },
    getLocalStorage(key) {
      try {
        return JSON.parse(localStorage[key])
      } catch (e) {
        return localStorage[key]
      }
    }
  }
}
